import { render, staticRenderFns } from "./rightSidebarStandardRow.vue?vue&type=template&id=25fc9446"
import script from "./rightSidebarStandardRow.vue?vue&type=script&lang=js"
export * from "./rightSidebarStandardRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports